<app-alert></app-alert>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <p><strong id="pageTitle">MBP-4B Register of Name of the bodies corporate, firms or other association of individuals as mentioned under sub-section (1) of section 184, in which any director is having any concern or interest</strong></p>
    </span>

    <span style="float:right">
      <button type="button"
        [appHasPermission]="{'Url': '/register/director/edit?goveva=true&email=', 'method':'put', 'menu': 'Director'}"
        class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" (click)="generateMbp4bDocument();"
        style="margin-right: 8px;">
        <!-- <span> <i class="fa fa-plus"></i>Generate Document (MBP 4B)</span> -->
        <span>
          <i class="fa fa-save"></i>&nbsp;Generate Output
        </span>
      </button>
    </span>

  </div>
  <!-- Date Filter  -->
  <section class="card search-box">
    <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
          class="fa fa-filter" aria-hidden="true"></i></span> </div>
    <div class="card-block collapse" id="search-div"  [ngClass]="{'collapse': !isSearchDivVisible}">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">

            <div class="col-md-3">
              <br>
              <div class="input-group" (click)="$event.stopPropagation()">
                <!-- <label>Date of Cessation/relinquishment</label> -->
                From:&nbsp;
                <input id="CessationDate" class="form-control" [minDate]="futureToDate" style="padding:6px;z-index: 0;"
                  placeholder="dd-mm-yyyy" name="CessationDate" ngbDatepicker #ab="ngbDatepicker"
                  (click)="ab.toggle();bc.close()" [(ngModel)]="CessationDate">
                <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
              </div>
            </div>

            <div class="col-md-3">
              
              <br>
              <div class="input-group" (click)="$event.stopPropagation()">
                <!-- <label>Date of Appointment</label> -->
                 To:&nbsp;
                <input id="AppointmentDate" class="form-control" [minDate]="futureToDateTo"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="AppointmentDate" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="AppointmentDate">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
              </div>
            </div>


            <div class="form-group col-lg-2 col-md-2 col-sm-2">
              <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
              <br>
              <div class="input-group">
                <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                  <i class="fa fa-search"></i>&nbsp;Search</button>
                &nbsp;&nbsp;&nbsp;
                <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                  (click)="clearAdvSearch()">
                  <i class="fa fa-refresh"></i>&nbsp;Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Date filter End -->

  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">
          <div class="table-responsive">
            <table datatable [dtOptions]="dtOptionsOfDirectorship" [dtTrigger]="dtTriggerOfDirectorship"
              class="table table-hover compact cell-border nowrap stripe" id="directorshipTable"
              style="cursor: pointer;">
              <thead>
                <tr>

                  <th>Director Name</th>
                  <th>Names of the Companies <br>/bodies corporate/ firms/ <br>association of individuals</th>
                  <th>Type of Company</th>
                  <th>Nature of Interest</th>
                  <th>Date of Cessation/ <br>relinquishment</th>
                  <th>Date of Appointment</th>


                  <th style="display: none;" class="actionclass">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let director of directorshipArray;let i=index">
                  <td> {{director.DirectorMaster[0].FirstName + " "+ director.DirectorMaster[0].LastName}} </td>

                  <td>
                    {{director.OfficeName}}

                  </td>
                  <td>
                    {{director.OfficeType}}
                  </td>
                  <td> {{director.Designation}}</td>

                  <td>
                    {{director.CessationDate | date : "dd-MM-y"}}
                  </td>

                  <td>
                    {{director.AppointmentDate | date : "dd-MM-y"}}
                  </td>







                  <td style="display: none;">

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>